(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["stas-product-carousel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('stas-product-carousel')) {
    customElements.define(
      'stas-product-carousel',
      class StasProductCarousel extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;
          this.initialized = true;
          this.viewport = this.querySelector('[data-stas-viewport]');
          this.track = this.querySelector('[data-stas-track]');
          this.previousButton = this.querySelector('[data-stas-previous]');
          this.nextButton = this.querySelector('[data-stas-next]');
          this.currentOutput = this.querySelector('[data-stas-current]');
          this.totalOutput = this.querySelector('[data-stas-total]');
          this.progressOutput = this.querySelector('[data-stas-progress]');
          this.total = Number(this.dataset.total || 0);
          this.nextPage = Number(this.dataset.nextPage || 0);
          this.interval = Math.max(2000, Number(this.dataset.interval || 4000));
          this.autoplay = this.dataset.autoplay === 'true';
          this.currentIndex = 0;
          this.position = 0;
          this.ringMode = this.nextPage === 0;
          this.busy = false;
          this.loading = false;
          this.isVisible = false;
          this.isHovering = false;
          this.isDragging = false;
          this.dragMoved = false;
          this.pauseUntil = 0;
          this.timer = null;
          this.abortController = new AbortController();
          this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
          this.onReducedMotionChange = () => this.schedule();

          if (!this.viewport || !this.track || this.total < 1) return;

          this.bindEvents();
          this.observeVisibility();
          this.updateIndicator();
          this.resetTransform();
          this.schedule();
        }

        disconnectedCallback() {
          window.clearTimeout(this.timer);
          if (this.observer) this.observer.disconnect();
          if (this.abortController) this.abortController.abort();
          if (this.reducedMotion && this.onReducedMotionChange) {
            this.reducedMotion.removeEventListener('change', this.onReducedMotionChange);
          }
          this.initialized = false;
        }

        bindEvents() {
          const signal = this.abortController.signal;

          if (this.nextButton) {
            this.nextButton.addEventListener('click', () => this.manualMove(1), { signal });
          }

          if (this.previousButton) {
            this.previousButton.addEventListener('click', () => this.manualMove(-1), { signal });
          }

          this.viewport.addEventListener(
            'keydown',
            (event) => {
              if (event.key === 'ArrowRight') {
                event.preventDefault();
                this.manualMove(1);
              }
              if (event.key === 'ArrowLeft') {
                event.preventDefault();
                this.manualMove(-1);
              }
            },
            { signal }
          );

          this.addEventListener(
            'pointerenter',
            (event) => {
              if (event.pointerType === 'mouse') {
                this.isHovering = true;
                this.stop();
              }
            },
            { signal }
          );

          this.addEventListener(
            'pointerleave',
            (event) => {
              if (event.pointerType === 'mouse') {
                this.isHovering = false;
                this.pauseForManualInteraction();
              }
            },
            { signal }
          );

          this.addEventListener('focusin', () => this.stop(), { signal });
          this.addEventListener(
            'focusout',
            () => {
              window.setTimeout(() => {
                if (!this.contains(document.activeElement)) this.pauseForManualInteraction();
              }, 0);
            },
            { signal }
          );

          this.viewport.addEventListener('pointerdown', (event) => this.onPointerDown(event), { signal });
          this.viewport.addEventListener('pointermove', (event) => this.onPointerMove(event), { signal });
          this.viewport.addEventListener('pointerup', (event) => this.onPointerUp(event), { signal });
          this.viewport.addEventListener('pointercancel', (event) => this.onPointerUp(event), { signal });
          this.viewport.addEventListener(
            'click',
            (event) => {
              if (this.dragMoved) {
                event.preventDefault();
                event.stopPropagation();
                this.dragMoved = false;
              }
            },
            { capture: true, signal }
          );

          this.addEventListener(
            'submit',
            (event) => {
              const form = event.target.closest('[data-stas-cart-form]');
              if (form && this.contains(form)) this.addToCart(event, form);
            },
            { signal }
          );

          document.addEventListener('visibilitychange', () => this.schedule(), { signal });
          window.addEventListener('resize', () => this.onResize(), { signal });
          this.reducedMotion.addEventListener('change', this.onReducedMotionChange);
        }

        observeVisibility() {
          if (!('IntersectionObserver' in window)) {
            this.isVisible = true;
            return;
          }

          this.observer = new IntersectionObserver(
            (entries) => {
              this.isVisible = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.15;
              this.schedule();
            },
            { threshold: [0, 0.15, 0.6] }
          );
          this.observer.observe(this);
        }

        onResize() {
          window.cancelAnimationFrame(this.resizeFrame);
          this.resizeFrame = window.requestAnimationFrame(() => this.resetTransform());
        }

        getVisibleCount() {
          return Math.max(
            1,
            Math.round(Number.parseFloat(getComputedStyle(this).getPropertyValue('--stas-visible')) || 1)
          );
        }

        getStep() {
          const firstCard = this.track.querySelector('[data-stas-product-id]');
          if (!firstCard) return 0;
          const gap = Number.parseFloat(getComputedStyle(this.track).columnGap) || 0;
          return firstCard.getBoundingClientRect().width + gap;
        }

        resetTransform() {
          if (!this.track) return;
          const offset = this.ringMode ? 0 : this.position * this.getStep();
          this.track.style.transform = 'translate3d(' + -offset + 'px, 0, 0)';
        }

        stop() {
          window.clearTimeout(this.timer);
          this.timer = null;
        }

        canAutoplay() {
          return (
            this.autoplay &&
            !this.reducedMotion.matches &&
            !document.hidden &&
            this.isVisible &&
            !this.isHovering &&
            !this.isDragging &&
            !this.contains(document.activeElement) &&
            Date.now() >= this.pauseUntil &&
            this.total > 1
          );
        }

        schedule(delay) {
          this.stop();
          if (!this.canAutoplay()) return;
          const remainingPause = Math.max(0, this.pauseUntil - Date.now());
          const wait = Math.max(delay || this.interval, remainingPause);
          this.timer = window.setTimeout(() => this.move(1, false), wait);
        }

        pauseForManualInteraction() {
          this.pauseUntil = Date.now() + 8000;
          this.schedule(8000);
        }

        manualMove(direction) {
          this.pauseForManualInteraction();
          this.move(direction, true);
        }

        async move(direction, manual) {
          if (this.busy || this.total < 2) return;
          this.busy = true;

          try {
            if (direction > 0) {
              await this.moveNext();
            } else {
              await this.movePrevious();
            }
          } finally {
            this.busy = false;
            this.updateIndicator();
            this.schedule(manual ? 8000 : this.interval);
          }
        }

        async moveNext() {
          if (!this.ringMode) {
            await this.ensureProductsAhead();
          }

          const step = this.getStep();
          if (!step) return;

          if (this.ringMode) {
            this.classList.add('is-animating');
            this.track.style.transform = 'translate3d(' + -step + 'px, 0, 0)';
            await this.waitForTransition();
            this.track.appendChild(this.track.firstElementChild);
            this.classList.remove('is-animating');
            this.track.style.transform = 'translate3d(0, 0, 0)';
          } else {
            this.position += 1;
            this.classList.add('is-animating');
            this.track.style.transform = 'translate3d(' + -(this.position * step) + 'px, 0, 0)';
            await this.waitForTransition();
            this.classList.remove('is-animating');
          }

          this.currentIndex = (this.currentIndex + 1) % this.total;
        }

        async movePrevious() {
          if (!this.ringMode) {
            await this.loadAllProducts();
            this.enableRingMode();
          }

          const step = this.getStep();
          if (!step) return;

          this.track.insertBefore(this.track.lastElementChild, this.track.firstElementChild);
          this.track.style.transform = 'translate3d(' + -step + 'px, 0, 0)';
          this.track.getBoundingClientRect();
          this.classList.add('is-animating');
          this.track.style.transform = 'translate3d(0, 0, 0)';
          await this.waitForTransition();
          this.classList.remove('is-animating');
          this.currentIndex = (this.currentIndex - 1 + this.total) % this.total;
        }

        waitForTransition() {
          return new Promise((resolve) => {
            let finished = false;
            const done = () => {
              if (finished) return;
              finished = true;
              this.track.removeEventListener('transitionend', done);
              resolve();
            };
            this.track.addEventListener('transitionend', done, { once: true });
            window.setTimeout(done, this.reducedMotion.matches ? 30 : 500);
          });
        }

        async ensureProductsAhead() {
          const loaded = this.track.querySelectorAll('[data-stas-product-id]').length;
          const visible = this.getVisibleCount();
          if (this.nextPage && this.position + visible + 3 >= loaded) {
            await this.loadNextBatch();
          }
          if (!this.nextPage) this.enableRingMode();
        }

        async loadAllProducts() {
          while (this.nextPage) {
            const loaded = await this.loadNextBatch();
            if (!loaded) break;
          }
        }

        async loadNextBatch() {
          if (this.loading || !this.nextPage) return false;
          this.loading = true;

          try {
            const requestUrl = new URL(this.dataset.batchUrl, window.location.origin);
            requestUrl.searchParams.set('section_id', 'stas-carousel-batch');
            requestUrl.searchParams.set('page', String(this.nextPage));
            requestUrl.searchParams.set('_stas_carousel', this.dataset.carouselStyle);

            const response = await fetch(requestUrl.toString(), {
              credentials: 'same-origin',
              headers: { 'X-Requested-With': 'XMLHttpRequest' }
            });
            if (!response.ok) throw new Error('Carousel batch request failed');

            const html = await response.text();
            const documentFragment = new DOMParser().parseFromString(html, 'text/html');
            const batch = documentFragment.querySelector('[data-stas-carousel-batch]');
            if (!batch) throw new Error('Carousel batch response is invalid');

            const known = new Set(
              Array.from(this.track.querySelectorAll('[data-stas-product-id]')).map(
                (card) => card.dataset.stasProductId
              )
            );

            let appended = 0;
            batch.querySelectorAll('[data-stas-product-id]').forEach((card) => {
              if (known.has(card.dataset.stasProductId)) return;
              known.add(card.dataset.stasProductId);
              this.track.appendChild(card);
              appended += 1;
            });

            this.nextPage = Number(batch.dataset.nextPage || 0);
            this.total = Number(batch.dataset.total || this.total);
            this.dataset.nextPage = this.nextPage ? String(this.nextPage) : '';
            this.dataset.total = String(this.total);
            if (this.totalOutput) this.totalOutput.textContent = String(this.total);
            return appended > 0;
          } catch (error) {
            console.error('[STAS carousel]', error);
            this.nextPage = 0;
            return false;
          } finally {
            this.loading = false;
          }
        }

        enableRingMode() {
          if (this.ringMode) return;
          const cards = this.track.querySelectorAll('[data-stas-product-id]');
          if (cards.length < this.total) return;

          const rotations = Math.min(this.position, cards.length);
          for (let index = 0; index < rotations; index += 1) {
            this.track.appendChild(this.track.firstElementChild);
          }

          this.position = 0;
          this.ringMode = true;
          this.track.style.transform = 'translate3d(0, 0, 0)';
        }

        updateIndicator() {
          if (this.currentOutput) this.currentOutput.textContent = String(this.currentIndex + 1);
          if (this.totalOutput) this.totalOutput.textContent = String(this.total);
          if (this.progressOutput) {
            const percent = this.total ? ((this.currentIndex + 1) / this.total) * 100 : 0;
            this.progressOutput.style.width = percent + '%';
          }
        }

        onPointerDown(event) {
          if (event.button !== undefined && event.button !== 0) return;
          if (
            event.pointerType !== 'touch' &&
            event.target.closest('a, button, input, select, textarea, label')
          ) {
            return;
          }
          this.stop();
          this.isDragging = true;
          this.dragMoved = false;
          this.dragStartX = event.clientX;
          this.dragDeltaX = 0;
          this.dragPointerId = event.pointerId;
          this.classList.add('is-dragging');
        }

        onPointerMove(event) {
          if (!this.isDragging) return;
          this.dragDeltaX = event.clientX - this.dragStartX;
          if (Math.abs(this.dragDeltaX) > 6 && !this.dragMoved) {
            this.dragMoved = true;
            if (this.viewport.setPointerCapture) {
              this.viewport.setPointerCapture(this.dragPointerId);
            }
          }
          const baseOffset = this.ringMode ? 0 : this.position * this.getStep();
          this.track.style.transform =
            'translate3d(' + (-baseOffset + this.dragDeltaX) + 'px, 0, 0)';
        }

        onPointerUp(event) {
          if (!this.isDragging) return;
          this.isDragging = false;
          this.classList.remove('is-dragging');
          if (this.viewport.releasePointerCapture && this.viewport.hasPointerCapture(event.pointerId)) {
            this.viewport.releasePointerCapture(event.pointerId);
          }

          const threshold = Math.min(80, this.viewport.getBoundingClientRect().width * 0.18);
          const direction =
            this.dragDeltaX <= -threshold ? 1 : this.dragDeltaX >= threshold ? -1 : 0;
          this.pauseForManualInteraction();

          if (direction) {
            this.move(direction, true);
          } else {
            this.resetTransform();
          }
        }

        async addToCart(event, form) {
          event.preventDefault();
          const button = form.querySelector('[data-stas-add]');
          const status = form.querySelector('[data-stas-cart-status]');
          if (!button || button.disabled) return;

          const originalText = button.textContent;
          button.disabled = true;
          button.textContent = 'Dodavanje...';

          try {
            const response = await fetch(
              window.routes && window.routes.cart_add_url
                ? window.routes.cart_add_url
                : form.action,
              {
                method: 'POST',
                credentials: 'same-origin',
                headers: {
                  Accept: 'application/json',
                  'X-Requested-With': 'XMLHttpRequest'
                },
                body: new FormData(form)
              }
            );
            const result = await response.json();
            if (!response.ok || result.status) {
              throw new Error(result.description || result.message || 'Proizvod nije dodat u korpu.');
            }

            const cartResponse = await fetch(
              window.routes && window.routes.cart_url
                ? window.routes.cart_url + '.js'
                : '/cart.js',
              { credentials: 'same-origin', cache: 'no-store' }
            );
            const cartData = await cartResponse.json();
            this.updateCartBadges(cartData.item_count);

            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'stas-product-carousel',
                productVariantId: new FormData(form).get('id'),
                cartData: cartData
              });
            }

            document.dispatchEvent(
              new CustomEvent('cart:updated', { detail: { cart: cartData } })
            );
            if (status) status.textContent = 'Proizvod je dodat u korpu.';
            button.textContent = 'Dodato';
            window.setTimeout(() => {
              button.disabled = false;
              button.textContent = originalText;
            }, 1500);
          } catch (error) {
            if (status) status.textContent = error.message;
            button.disabled = false;
            button.textContent = originalText;
            console.error('[STAS carousel cart]', error);
          }
        }

        updateCartBadges(itemCount) {
          document.querySelectorAll('.stas-commerce-header__cart').forEach((cartLink) => {
            let badge = cartLink.querySelector('.stas-commerce-header__cart-count');
            if (itemCount > 0) {
              if (!badge) {
                badge = document.createElement('span');
                badge.className = 'stas-commerce-header__cart-count';
                cartLink.appendChild(badge);
              }
              badge.textContent = String(itemCount);
            } else if (badge) {
              badge.remove();
            }
          });

          const standardLink = document.getElementById('cart-icon-bubble');
          if (!standardLink) return;
          let standardBadge = standardLink.querySelector('.cart-count-bubble');
          if (itemCount > 0) {
            if (!standardBadge) {
              standardBadge = document.createElement('div');
              standardBadge.className = 'cart-count-bubble';
              standardBadge.innerHTML =
                '<span aria-hidden="true"></span><span class="visually-hidden"></span>';
              standardLink.appendChild(standardBadge);
            }
            const visibleCount = standardBadge.querySelector('span[aria-hidden="true"]');
            const accessibleCount = standardBadge.querySelector('.visually-hidden');
            if (visibleCount) visibleCount.textContent = String(itemCount);
            if (accessibleCount) accessibleCount.textContent = String(itemCount) + ' proizvoda u korpi';
          } else if (standardBadge) {
            standardBadge.remove();
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
